import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AbstractStateInterface } from '../../interface/abstract';
import { AnswerInterface } from '../../interface/answer';
import { ApiService } from '../../utils/apiService';

type DataState = AbstractStateInterface<AnswerInterface>;

const initialState: DataState = {
  data: [],
  detail: null,
  loading: false,
};
export const getListAnswers = createAsyncThunk('/admin-api/answers/list', async (_, thunkAPI) => {
  try {
    const response = await ApiService(`/admin-api/answers/list`, 'GET', null);
    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue({
        code: response.statusCode,
        error: response.error || 'Login failed',
      });
    }
    return {
      code: response.statusCode,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      code: error.response?.status || 500,
      error: error.message || 'Error',
    });
  }
});
const answersSlice = createSlice({
  name: 'answers',
  initialState,
  reducers: {
    resetAnswerSlice: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListAnswers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getListAnswers.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(action.payload.data)) {
          const fillEmail = action.payload.data.filter((item) => item.user.email);
          state.data = fillEmail as AnswerInterface[];
        } else {
          state.data = [];
        }
      })
      .addCase(getListAnswers.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const { resetAnswerSlice } = answersSlice.actions;
export default answersSlice.reducer;
